import { useState, useContext } from 'react';
import { Box, Select, MenuItem, FormControl } from '@mui/material';
import { ThemeContext } from '../Context';
import GuardiaVision from './GuardiaVision';
import GuardiaAudio from './GuardiaAudio';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import AudioFileIcon from '@mui/icons-material/AudioFile';

function GuardiaRight() {
  const { theme } = useContext(ThemeContext);
  const [mediaType, setMediaType] = useState('photo'); // 'photo' ou 'audio'

  // Déterminer si le thème est sombre
  const isDark = theme === 'dark';

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: isDark ? '#1a252f' : '#f8f9fa',
      }}
    >
      {/* Zone de contenu */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ flexGrow: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Sélecteur de type de média */}
          <Box sx={{ flexShrink: 0, px: 1.5, pt: 1, pb: 1 }}>
            <FormControl fullWidth size="small">
              <Select
                value={mediaType}
                onChange={(e) => setMediaType(e.target.value)}
                sx={{
                  backgroundColor: isDark ? '#22303e' : 'white',
                  color: isDark ? '#ecf0f1' : '#333',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: isDark ? '#34495e' : '#ddd',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: isDark ? '#c084fc' : '#800080',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: isDark ? '#c084fc' : '#800080',
                  },
                }}
              >
                <MenuItem value="photo">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PhotoCameraIcon sx={{ fontSize: '1.2rem', color: isDark ? '#c084fc' : '#800080' }} />
                    Description d'image
                  </Box>
                </MenuItem>
                <MenuItem value="audio">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AudioFileIcon sx={{ fontSize: '1.2rem', color: isDark ? '#c084fc' : '#800080' }} />
                    Transcription audio
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Composants selon le type de média */}
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Box sx={{ display: mediaType === 'photo' ? 'block' : 'none', height: '100%' }}>
              <GuardiaVision />
            </Box>

            <Box sx={{ display: mediaType === 'audio' ? 'block' : 'none', height: '100%' }}>
              <GuardiaAudio />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default GuardiaRight;
